/*
  Dailydream – Filter im mobilen Menü (Header Categories)
  Lädt beim Öffnen eines Menü-Tabs die Section „DD – Kollektion + Filter“
  der jeweiligen Kollektion nach und zeigt sie anstelle der bisherigen Karten.
  Filter, Karten, Ausverkauft-Logik und Klaviyo kommen 1:1 aus dieser Section.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var counter = 0;

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* Section-HTML der Kollektion holen (einmal pro Handle) */
  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + 'collections/' + encodeURIComponent(handle), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var sec = doc.querySelector('.dd-kollektion-filter-section');
          if (!sec || !sec.querySelector('[data-k-grid]')) return null;
          var noun = '';
          try { noun = (JSON.parse(sec.querySelector('[data-k-config]').textContent).finder || {}).noun || ''; } catch (e) {}
          return { html: sec.innerHTML, count: sec.querySelectorAll('[data-k-card]').length, noun: noun };
        })
        .catch(function (err) { delete cache[handle]; throw err; });
    }
    return cache[handle];
  }

  /* Handle aus data-tab-content („<block-id>-<handle>“) ableiten */
  function handleOf(list) {
    var tab = list.getAttribute('data-tab-content') || '';
    var dd = list.closest('[data-dropdown-id]');
    var bid = dd ? dd.getAttribute('data-dropdown-id') : '';
    return bid && tab.indexOf(bid + '-') === 0 ? tab.slice(bid.length + 1) : '';
  }

  /* Anzahl wie auf der Kollektionsseite („8 Produkte“) – zählt alle Produkte der Kollektion */
  function countLabel(list, res) {
    return res.count + (res.count === 1 ? ' Produkt' : ' Produkte');
  }

  function lock(on) { document.documentElement.classList.toggle('mf-lock', !!on); }

  function setup(list) {
    if (list._mf) return;
    list._mf = true;
    var handle = handleOf(list);
    if (!handle) return;
    list.classList.add('mf-list');

    var bar = el('div', 'mf-bar');
    var countEl = el('span', 'mf-count');
    bar.appendChild(countEl);
    var btn = el('button', 'mf-btn');
    btn.type = 'button';
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg><span>Filter</span>';
    bar.hidden = true;
    bar.appendChild(btn);
    list.insertBefore(bar, list.firstChild);

    var state = 'idle';
    var host = null, panel = null, toggle = null, overlay = null;

    /* Section unsichtbar einsetzen und starten, erste Kategorie wählen (z. B. „Topper“), Anzahl übernehmen */
    function prepare(res) {
      var html = res.html.replace(/DDK--([A-Za-z0-9_\-]+)/g, 'DDK--$1' + '-mf' + (++counter));
      host = el('div', 'mf-host');
      host.hidden = true;
      host.innerHTML = html;
      overlay = el('div', 'mf-overlay');
      overlay.hidden = true;
      host.appendChild(overlay);
      list.appendChild(host);

      /* Klicks im Filter nicht bis zum Dokument durchreichen: Das Menü schließt sich sonst,
         weil die Section ihre Buttons nach jedem Klick neu zeichnet und das Menü den Klick
         dann als „außerhalb“ wertet. */
      host.addEventListener('click', function (e) { e.stopPropagation(); });

      /* Per innerHTML eingefügte Scripts laufen nicht – neu erzeugen. JSON-Daten bleiben unberührt. */
      Array.prototype.forEach.call(host.querySelectorAll('script'), function (s) {
        var t = (s.getAttribute('type') || '').toLowerCase();
        if (t && t !== 'text/javascript' && t !== 'module') return;
        var n = document.createElement('script');
        if (t) n.type = t;
        n.textContent = s.textContent;
        s.parentNode.replaceChild(n, s);
      });

      var firstCat = host.querySelector('[data-k-tabs] .k-tab:nth-child(2)');
      if (firstCat) firstCat.click();

      panel = host.querySelector('[data-k-panel]');
      toggle = host.querySelector('[data-k-toggle]');
      if (panel) {
        new MutationObserver(function () {
          var open = panel.classList.contains('is-open');
          overlay.hidden = !open;
          lock(open);
        }).observe(panel, { attributes: true, attributeFilter: ['class'] });
        overlay.addEventListener('click', function () {
          panel.classList.remove('is-open');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
        var closeBtn = panel.querySelector('[data-k-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { lock(false); });
      }

      var cnt = host.querySelector('[data-k-count]');
      countEl.textContent = cnt && cnt.textContent.trim() ? cnt.textContent.trim() : countLabel(list, res);
      return !!(panel && toggle && !toggle.classList.contains('is-off'));
    }

    function check() {
      if (state !== 'idle') return;
      state = 'checking';
      load(handle).then(function (res) {
        var ok = res ? prepare(res) : false;
        state = ok ? 'ready' : 'none';
        bar.hidden = !ok;
      }).catch(function () { state = 'idle'; });
    }

    /* Filter antippen: Karten der Section zeigen und Filter-Sheet öffnen */
    function open() {
      if (!host) return;
      var old = list.querySelector('.header-categories__product-list-inner');
      if (old) old.style.display = 'none';
      bar.hidden = true;
      host.hidden = false;
      if (!panel.classList.contains('is-open')) toggle.click();
    }

    btn.addEventListener('click', function (e) { e.stopPropagation(); open(); });

    /* Erst prüfen, wenn der Tab geöffnet wird – kein Laden beim Seitenaufruf */
    if (list.classList.contains('active')) check();
    new MutationObserver(function () {
      if (list.classList.contains('active')) check();
    }).observe(list, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.header-categories__product-list[data-tab-content]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();